<template>
  <aside class="we-right-panel">
    <el-card shadow="never" class="we-setting-card">
      <div slot="header" class="we-card-title">
        <i class="el-icon-setting"></i>
        <span>作业设置</span>
      </div>

      <el-form label-position="top" size="small" class="we-setting-form">
        <el-form-item required>
          <span slot="label"><span class="we-required">*</span>名称</span>
          <el-input v-model="local.workname" placeholder="请输入作业名称" maxlength="100" />
        </el-form-item>

        <el-form-item label="学员提交日期">
          <div class="we-date-range">
            <el-date-picker v-model="local.beginTime" type="datetime" placeholder="开始时间"
              value-format="yyyy-MM-dd-HH:mm:ss" :readonly="timeReadonly" style="width: 100%" />
            <span class="we-sep">至</span>
            <el-date-picker v-model="local.endTime" type="datetime" placeholder="结束时间"
              value-format="yyyy-MM-dd-HH:mm:ss" :readonly="timeReadonly" style="width: 100%" />
          </div>
          <p class="we-tip">开始时间将发送作业提交提醒</p>
        </el-form-item>

        <el-form-item v-if="themebind == 1" label="请选择课节" required>
          <el-select v-model="local.lessonId" filterable placeholder="请选择课节" style="width: 100%">
            <el-option v-for="item in courselist" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="themetype != 4" label="答题时间设置">
          <el-radio-group v-model="local.isSettime">
            <el-radio label="false">不限时</el-radio>
            <el-radio label="true">
              限时
              <el-input-number v-model="local.setTime" :min="1" :controls="false" size="mini"
                style="width: 64px; margin: 0 4px" />
              分钟
            </el-radio>
          </el-radio-group>
          <p class="we-tip">超时将自动交卷</p>
        </el-form-item>

        <el-form-item label="提交规则">
          <el-checkbox v-model="local.edit">允许二次编辑</el-checkbox>
          <el-checkbox v-model="local.isLook">不可查看他人提交</el-checkbox>
          <el-checkbox v-if="themebind == 1" v-model="local.needStudy">课程看完方可提交</el-checkbox>
          <el-checkbox v-model="local.subagain">允许补交</el-checkbox>
          <template v-if="local.subagain">
            <div class="we-date-range we-date-range--sub">
              <el-date-picker v-model="local.subStart" type="datetime" placeholder="补交开始时间"
                value-format="yyyy-MM-dd-HH:mm:ss" style="width: 100%" />
              <span class="we-sep">至</span>
              <el-date-picker v-model="local.subEnd" type="datetime" placeholder="补交结束时间"
                value-format="yyyy-MM-dd-HH:mm:ss" style="width: 100%" />
            </div>
          </template>
        </el-form-item>

        <el-form-item v-if="themetype != 4" label="教师查看学生作业">
          <el-radio-group v-model="local.checkcommit">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="themetype != 4" label="教师批改作业">
          <el-radio-group v-model="local.isCheck">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="themetype != 4" label="学员端展示方式">
          <el-radio-group v-model="local.score">
            <el-radio label="true">总分数</el-radio>
            <el-radio label="false">优良等级</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-card>
  </aside>
</template>

<script>
  export default {
    name: 'WorkEditorSettingPanel',
    props: {
      value: {
        type: Object,
        required: true
      },
      themebind: {
        type: [String, Number],
        default: ''
      },
      themetype: {
        type: [String, Number],
        default: ''
      },
      courselist: {
        type: Array,
        default: () => []
      },
      timeReadonly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      local: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .we-right-panel {
    position: sticky;
    top: 16px;
    align-self: start;
    width: 100%;
    min-width: 0;
    height: fit-content;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .we-setting-card {
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    ::v-deep .el-card__header {
      padding: 12px 16px;
    }

    ::v-deep .el-card__body {
      padding: 6px 16px 14px;
    }
  }

  .we-setting-form {
    ::v-deep .el-form-item {
      margin-bottom: 12px;
    }

    ::v-deep .el-form-item__label {
      padding: 0 0 4px;
      line-height: 1.4;
      font-size: 13px;
      color: #4e5969;
    }

    ::v-deep .el-form-item__content {
      line-height: 1.5;
    }

    ::v-deep .el-radio {
      margin-right: 14px;
      line-height: 1.5;
    }

    ::v-deep .el-checkbox {
      display: block;
      margin-right: 0;
      margin-bottom: 6px;
      line-height: 1.5;
    }
  }

  .we-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;

    i {
      color: #4f6ef7;
    }
  }

  .we-required {
    color: #f7607d;
    margin-right: 2px;
  }

  .we-date-range {
    display: flex;
    flex-direction: column;
    gap: 6px;

    &--sub {
      margin-top: 6px;
    }
  }

  .we-sep {
    color: #86909c;
    font-size: 12px;
    line-height: 1;
    text-align: center;
  }

  .we-tip {
    margin: 4px 0 0;
    font-size: 12px;
    color: #86909c;
    line-height: 1.4;
  }
</style>
